import api from '@common/api';
import { Subscription } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface SubscriptionModelProps {
  subscription?: Subscription;
  subscriptions: Subscription[];
}
interface SubscriptionModelActions {
  fetchSubscriptions: (investorID: string) => Promise<Subscription[]>;
  setSubscription: (subscription?: Subscription | null) => void;
  setSubscriptions: (subscriptions: Subscription[]) => void;
}

export const SubscriptionModel = createStore(
  persist<SubscriptionModelProps & SubscriptionModelActions>(
    (set) => ({
      fetchSubscriptions: async (investorID: string) => {
        const subscriptions = await api.listSubscriptions({ investor_account_id: investorID });
        set({ subscriptions });
        return subscriptions;
      },
      setSubscription: (subscription) => {
        if (subscription) {
          set({ subscription });
        }
      },
      setSubscriptions: (subscriptions) => {
        set({ subscriptions });
      },
      subscriptions: [],
    }),
    {
      getStorage: () => localStorage,
      name: 'subscription-model',
    },
  ),
);

export function useSubscriptionModel(): SubscriptionModelProps & SubscriptionModelActions;
export function useSubscriptionModel<T>(
  selector: (state: SubscriptionModelProps & SubscriptionModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;
export function useSubscriptionModel<T>(
  selector?: (state: SubscriptionModelProps & SubscriptionModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(SubscriptionModel, selector!, equals);
}
